import type { SendSeverityLevel } from '@/model/Agent.model';
import styles from './SendResults.module.scss';

/** Each level's pill colours, shared by the findings' badges and the section headers' count pills. */
export const severityBadgeClass: Record<SendSeverityLevel, string> = {
  reject: styles.badgeReject,
  error: styles.badgeError,
  warning: styles.badgeWarning,
  notice: styles.badgeNotice,
  advisory: styles.badgeAdvisory,
};

/** Each level's mark shape, so no level is told apart by colour alone. */
export const severityMarkClass: Record<SendSeverityLevel, string> = {
  reject: styles.markReject,
  error: styles.markError,
  warning: styles.markWarning,
  notice: styles.markNotice,
  advisory: styles.markAdvisory,
};
